import { render, staticRenderFns } from "./SlidingBayImpacts.vue?vue&type=template&id=54245756&scoped=true"
import script from "./SlidingBayImpacts.vue?vue&type=script&lang=ts"
export * from "./SlidingBayImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54245756",
  null
  
)

export default component.exports